import Categories from '../../services/Categories';
import { CRUD_TYPES } from '../../helpers/constants';
import Helper from '../../helpers/Helper';

export const LOADING_CATEGORIES = 'LOADING_CATEGORIES';
const loadingCategories = () => ({
  type: LOADING_CATEGORIES,
});

export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';
const receiveCategories = categories => ({
  type: RECEIVE_CATEGORIES,
  categories,
});

export const getCategories = () => {
  return async dispatch => {
    dispatch(loadingCategories());
    try {
      const response = await new Categories().get();
      if (response) {
        dispatch(receiveCategories(response.data));
      }
      return response;
    } catch (error) {
      console.log('Error in get categories', error);
      return Helper.formatApiErrorResponse({
        response: error.response,
        message: 'Erro. Atualize a página',
      });
    }
  };
};

export const LOADING_SUBMIT_CATEGORY = 'LOADING_SUBMIT_CATEGORY';
export const loadingSubmitCategory = () => ({
  type: LOADING_SUBMIT_CATEGORY,
});

export const SUBMIT_CATEGORY_SUCCESS = 'SUBMIT_CATEGORY_SUCCESS';
export const saveCategorySuccess = () => ({
  type: SUBMIT_CATEGORY_SUCCESS,
});

export const CATEGORY_REQUEST_ERROR = 'CATEGORY_REQUEST_ERROR';
const errorCategory = error => ({
  type: CATEGORY_REQUEST_ERROR,
  error,
});

export function saveCategory(data) {
  return async dispatch => {
    return submitCategory(null, data, dispatch, CRUD_TYPES.SAVE);
  };
}

async function submitCategory(id, data, dispatch, type) {
  dispatch(loadingSubmitCategory());
  try {
    let response = null;
    const service = new Categories();
    if (type === CRUD_TYPES.EDIT) {
      response = await service.put(id, data);
    } else if (type === CRUD_TYPES.SAVE) {
      response = await service.post(data);
    } else if (type === 'sortOrder') {
      response = await service.sortOrder(data);
    }
    if (!response) {
      throw new Error('Erro ao submeter categoria, tente novamente mais tarde');
    }
    dispatch(saveCategorySuccess());
    return response.data;
  } catch (err) {
    dispatch(
      errorCategory({
        message:
          err.response && err.response.data.message && err.response.data.message.name
            ? err.response.data.message.name
            : 'Erro! Verifique os dados e tente novamente',
      })
    );
    console.error('error', err.message);
  }
}

export function editCategory(id, data) {
  return async dispatch => {
    return submitCategory(id, data, dispatch, CRUD_TYPES.EDIT);
  };
}

export function sortOrderCategory(data) {
  return async dispatch => {
    submitCategory(null, data, dispatch, 'sortOrder');
  };
}



// WEBPACK FOOTER //
// ./src/store/categories/actions.js